import { Suspense, useEffect } from 'react'
import { useLocation, useOutlet } from 'react-router'
import queryString from 'query-string'

import { PaymentPlanProvider } from './providers/PaymentPlanProvider'
import { FlowContext, FlowContextProvider } from 'directFlow/utils/FlowContext'
import Loader from 'components/Loader'
import { ScrollToTop } from 'components/ScrollToTop'

import { CoreQuoteService } from 'app/CoreQuoteService'
import { Storage as storage } from 'utils'

export const PostQuoteRoutes = () => {
  const location = useLocation()
  const outlet = useOutlet()

  useEffect(() => {
    const ctmClickId = queryString.parse(location.search)['ClickthroughId']

    if (ctmClickId) {
      storage.set('ClickthroughId', ctmClickId)
    }
  }, [location])

  return (
    <Suspense fallback={<Loader />}>
      <FlowContextProvider value={FlowContext.POST_QUOTE}>
        <ScrollToTop>
          <PaymentPlanProvider>
            <CoreQuoteService>{outlet}</CoreQuoteService>
          </PaymentPlanProvider>
        </ScrollToTop>
      </FlowContextProvider>
    </Suspense>
  )
}
